import $ from 'jquery';
import PresentationSlider from '../blocks/PresentationSlider';
import SpeakersSlider from '../blocks/SpeakersSlider';
import SliderTwoColumns from '../blocks/SlidersTwoColumns';
import ProgrammePresentation from '../blocks/ProgrammePresentation';
import EEFEContentOutline from '../blocks/EEFEContentOutline';
import ThumbsSlider from '../blocks/ThumbsSlider';
import QuoteSlider from '../blocks/QuoteSlider';
import 'materialize-css'

export default {
    handleHashChange() {
        const hash = window.location.hash;
        const menuItem = jQuery('.nav-primary ul > li > a[href="' + hash + '"]');
        if (hash && menuItem) {
          jQuery('.nav-primary ul > li').removeClass('current-menu-item');
          menuItem.parent().addClass('current-menu-item');
        }
    },
    init() {
        /*
         * JavaScript to be fired on all pages
         */
        this.handleHashChange();
        
        const el = this;
        window.addEventListener('hashchange', function() {
          el.handleHashChange();
        });

        // PARALLAX HEADER
        $('.page-header .parallax-container').css('height', $('.page-header').height());
        $('.parallax').parallax();

        $(window).on('resize', function () {
            $('.page-header .parallax-container').css('height', $('.page-header').height());
            $('.parallax').parallax();
        });

        // TABLE OF CONTENT
        const $iaColumns = $('#main-content .international-columns');
        const $tableOfContent = $('.js--sticky-toc-container');

        if ($iaColumns.length > 0) {
            let activated = true;
            $iaColumns.each(function () {
                let li = $(this).attr('data-table-content-title');
                if (li === '') {
                    li = $(this).find('.block-title').html();
                }
                if ($(this).attr('data-toc-activated') === 'false') {
                    activated = false;
                }
                $tableOfContent.find('ul.menu').append('<li><a href="#' + $(this).find('.block-title').attr('id') + '" title="' + li + '" class="toc-link font-bold color-black">' + li + '</a></li>');
            });

            if (!activated) {
                $tableOfContent.find('.sticky').foundation('_destroy');
                $tableOfContent.css({'height': 'auto', 'margin-bottom' : '50px'});
                $tableOfContent.find('.sticky-toc').css('width', '100%');
            }

            $tableOfContent.removeClass('hide');
        }

        // IA ACCORDIONS
        
        $('.ia-accordions').each(function(){
            let maxWidthNumber = 50;
            $(this).find('.accordion-title').each(function() {
                const itemWidth = $(this).find('span:first-child').outerWidth();
                maxWidthNumber = maxWidthNumber < itemWidth ? itemWidth : maxWidthNumber;
            })
            $(this).find('.accordion-title > span:first-child').width(maxWidthNumber);
        });

        // GRAVITY FROM DATE MONTH SELECT : USE MONTH LABEL INSTEAD OF INT
    
        const select_month_options = jQuery('.gfield_date_dropdown_month option');
        const current_language = jQuery('html').attr('lang').substring(0, 2);
        let month_names = [ 'month', 'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december' ];
        if (current_language === 'fr') {
            month_names = [ 'mois', 'janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre' ];
        }
        jQuery.each(select_month_options, function( key, option ) {
            console.log(option);
            const value = option.value;
            if ( '' !== value ) {
                option.label = month_names[value];
            }
        });

        // LOAD MODULES
        PresentationSlider();
        ProgrammePresentation();
        EEFEContentOutline();
        ThumbsSlider();
        SpeakersSlider();
        QuoteSlider();
        SliderTwoColumns();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
